import { useEffect, useState } from "react";
import logo from '../../assets/img/logos/simple events logo.png';
import image1 from '../../assets/img/gallery/simplify.jpg';
import image2 from '../../assets/img/gallery/engageA.jpg';
import image3 from '../../assets/img/gallery/coordinate.jpg';
import image4 from '../../assets/img/gallery/hallway2.jpg';
import InputField from "../../components/inputs/inputField";
import SelectField from "../../components/inputs/selectField";
import axios from "axios";
import FileUploadInputBox from "../../components/inputs/fileUploadInputBox";
import ColorField from "../../components/inputs/colorField";
import API from "../../utils/API";

const sizeOptions = [
    { label: '1-10', value: '1-10' },
    { label: '11-50', value: '11-50' },
    { label: '51-200', value: '51-200' },
    { label: '201-500', value: '201-500' },
    { label: '500+', value: '500+' }
]

const industryOptions = [
    { label: 'Technology', value: 'Technology' },
    { label: 'Finance', value: 'Finance' },
    { label: 'Healthcare', value: 'Healthcare' },
    { label: 'Retail', value: 'Retail' },
    { label: 'Education', value: 'Education' },
    { label: 'Manufacturing', value: 'Manufacturing' },
    { label: 'Other', value: 'Other' },
]

const countryOptions = [
    { label: 'United States', value: 'US' },
    { label: 'Canada', value: 'CA' },
    { label: 'United Kingdom', value: 'UK' },
    { label: 'Australia', value: 'AU' },
    { label: 'India', value: 'IN' },
    { label: 'Other', value: 'Other' },
]

const Onboard = () => {

    useEffect(() => {
        //check if already part of an org and set it as default org and send them there
        const defaultOrganization = localStorage.getItem('defaultOrganization');
        if (defaultOrganization) {
            window.location.replace(`/${defaultOrganization}/events`);
        }
    }, []);

    function createOrganization(organization) {
        API().post('/auth/createOrganization', { organization }).then((res) => {
            const orgId = res.data._id;
            localStorage.setItem('defaultOrganization', orgId);
            window.location.replace(`/${orgId}/events`);
        }).catch((e) => {
            console.log(e);
        })
    }

    const [step, setStep] = useState(1);

    function Step1() {
        const [slideIndex, setSlideIndex] = useState(0);
        const [progress, setProgress] = useState(0);
        const [timerOn, setTimerOn] = useState(true);

        const images = [image1, image2, image3, image4];

        function nextSlide() {
            if (slideIndex < 3) {
                setSlideIndex(slideIndex + 1);
                setProgress(0);
            }
        }

        function prevSlide() {
            if (slideIndex > 0) {
                setSlideIndex(slideIndex - 1);
                setProgress(0);
            }
        }

        useEffect(() => {
            if (timerOn) {
                const interval = setInterval(() => {
                    setProgress((prev) => {
                        if (prev >= 100) {
                            if (slideIndex < 3) {
                                nextSlide();
                                return 0;
                            } else {
                                return 100;
                            }
                        }
                        return prev + 1;
                    });
                }, 100);
                return () => clearInterval(interval);
            }
        }, [slideIndex, timerOn]);

        return (
            <div className="flex w-100 h-100">
                <div className="flex flex-column h-100 jcc white" style={{ background: '#001229', width: '60%', paddingLeft: 150, paddingRight: 50 }}>
                    <div className="mb-30">
                        <img src={logo} alt="logo" style={{ maxHeight: 'unset', height: 25, filter: 'invert(1)' }} />
                    </div>
                    <div className="flex jcsb">
                        <div>
                            <h1>Plan. Promote. Deliver.</h1>
                            <h2 className="se-blue"><i>Your Partner in Corporate Event Success</i></h2>
                        </div>
                        <div className="mt-a">
                            <button className="contained white" onClick={() => {
                                setStep(2);
                            }}>Skip & continue</button>
                        </div>
                    </div>

                    <div className="mt-50 sectionCarousel">
                        <div className={`carouselItem ${slideIndex === 0 ? 'selected' : ''}`} onClick={() => { setSlideIndex(0); setProgress(0); }}>
                            <div className="progressbar">
                                <div className="progress" style={{ height: `${slideIndex === 0 ? progress : 0}%` }}></div>
                            </div>
                            <div className="carouselItemContent">
                                <h3>Simplify Event Management</h3>
                                <p>Access tools for attendee tracking, schedule creation, and branded communication, all in one place.</p>
                            </div>
                        </div>
                        <div className={`carouselItem ${slideIndex === 1 ? 'selected' : ''}`} onClick={() => { setSlideIndex(1); setProgress(0); }}>
                            <div className="progressbar">
                                <div className="progress" style={{ height: `${slideIndex === 1 ? progress : 0}%` }}></div>
                            </div>
                            <div className="carouselItemContent">
                                <h3>Engage Attendees Effortlessly</h3>
                                <p>Leverage customized registration pages, email campaigns, and mobile apps to deliver memorable experiences.</p>
                            </div>
                        </div>
                        <div className={`carouselItem ${slideIndex === 2 ? 'selected' : ''}`} onClick={() => { setSlideIndex(2); setProgress(0); }}>
                            <div className="progressbar">
                                <div className="progress" style={{ height: `${slideIndex === 2 ? progress : 0}%` }}></div>
                            </div>
                            <div className="carouselItemContent">
                                <h3>Save Time, Increase Impact</h3>
                                <p>Automate workflows, streamline approvals, and manage every detail—so you can focus on making your events successful.</p>
                            </div>
                        </div>
                        <div className={`carouselItem ${slideIndex === 3 ? 'selected' : ''}`} onClick={() => { setSlideIndex(3); setProgress(0); }}>
                            <div className="progressbar">
                                <div className="progress" style={{ height: `${slideIndex === 3 ? progress : 0}%` }}></div>
                            </div>
                            <div className="carouselItemContent">
                                <h3>Built for Scale</h3>
                                <p>Whether it’s a one-time event or a series of recurring events, Simple Events adapts to meet your evolving needs.</p>
                            </div>
                        </div>
                    </div>

                    <div className="flex jcc mt-50" style={{ width: 'fit-content' }}>
                        {slideIndex > 0 && <button className="outline mr-20" onClick={prevSlide}>
                            <i className="las la-arrow-up mr-5 white"></i>
                            <span className="white">Previous</span>
                        </button>}
                        {slideIndex < 3 ? <button className="prim" onClick={nextSlide}>
                            <i className="las la-arrow-down mr-5 white"></i>
                            <span className="mr-5">Next</span>
                        </button> : <button className="prim" onClick={() => {
                            setStep(2);
                        }}>
                            Continue
                        </button>}
                    </div>
                </div>
                <div className="ImageCarousel">
                    {images.map((image, index) => (
                        <img key={index} src={image} alt="carousel" className={`carouselImage ${index === slideIndex ? 'selected' : ''}`} />
                    ))}
                </div>
            </div>
        )
    }

    function Step2() {
        const [activePart, setActivePart] = useState(0);
        const [orgIdEdited, setOrgIdEdited] = useState(false);
        const [organization, setOrganization] = useState({
            name: '',
            identifier: '',
            size: '',
            industry: '',
            country: '',
            branding: {
                logo: '',
                favicon: '',
                fontColor: '',
                accentColor: '',
                backgroundColor: '',
                textColor: '',
                fonts: []
            }
        });
        const [disableSubmit, setDisableSubmit] = useState(false);
        const [fontOptions, setFontOptions] = useState([]);
        const [nameErrorTrigger, setNameErrorTrigger] = useState(false);
        const [identifierErrorTrigger, setIdentifierErrorTrigger] = useState(false);

        useEffect(() => {
            axios.get(`https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyDvDVvkn5-FAGP-pb4vA2azGooK63V2RD8`).then((res) => {
                let options = [];
                res.data.items.forEach((font) => {
                    font.variants.forEach((variant) => {
                        var apiUrl = [];
                        apiUrl.push('https://fonts.googleapis.com/css?family=');
                        apiUrl.push(font.family.replace(/ /g, '+'));
                        apiUrl.push(':');
                        apiUrl.push(variant);
                        const url = apiUrl.join('');
                        options.push({
                            label: font.family + ' ' + variant,
                            value: url,
                            font: font.family,
                            variant: variant
                        });
                    });
                });
                setFontOptions(options);
            }).catch((e) => {
                console.log(e);
            })
        }, []);

        function continueToNextPart() {
            if (activePart === 0) {
                if (!organization.name || !organization.identifier) {
                    setNameErrorTrigger(!organization.name);
                    setIdentifierErrorTrigger(!organization.identifier);
                    return;
                }
                setActivePart(1);
            } else {
                setDisableSubmit(true);
                createOrganization(organization);
            }
        }

        return (
            <div className="flex w-100 h-100">
                <div className="flex flex-column h-100 w-100 aic " style={{ background: '#001229' }}>
                    <div className="flex aic white" style={{ height: 70 }}>
                        <img src={logo} alt="logo" style={{ maxHeight: 'unset', height: 25, filter: 'invert(1)' }} />
                        <i className="las la-times se-blue mr-10 ml-10" ></i>
                        <h2 style={{ fontSize: 20 }}>Your Organization</h2>
                    </div>
                    <div className="flex aic gap10 white" >
                        <div className={`partProgressBar ${activePart === 0 ? 'started' : 'finished'}`}>
                            <div className="partProgress"></div>
                        </div>
                        <div className={`partProgressBar ${activePart === 1 ? 'started' : ''}`}>
                            <div className="partProgress"></div>
                        </div>
                    </div>
                    <div className="mt-30 mb-10 white">
                        <p className="small">STEP {activePart + 1} / 2</p>
                    </div>
                    <h1 className="mb-10 white">Tell us about your organization</h1>
                    <p className="small mb-30 white">
                        This will setup your workspace and how attendees find your events.
                    </p>
                    <div className='neuCard w-100' style={{ background: 'white', border: 'none', maxWidth: 480, padding: 30 }}>
                        {activePart === 0 && <>
                            <h1 className='text-c mb-30' style={{ fontWeight: 500, fontSize: 24 }}> Setup your workspace</h1>
                            <InputField
                                label={'Organization Name'}
                                type={'text'}
                                value={organization.name}
                                errorTrigger={nameErrorTrigger}
                                errorMessage={'Name is required'}
                                placeholder="E.g. Acme Inc."
                                onChange={(e) => {
                                    const updatedOrg = { ...organization, name: e.target.value }
                                    if (!orgIdEdited) {
                                        updatedOrg.identifier = e.target.value.toLowerCase().replace(/\s/g, '');
                                    }
                                    setOrganization(updatedOrg);
                                    setNameErrorTrigger(false);
                                }}
                            />
                            <InputField
                                label={'Organization Identifier'}
                                type={'text'}
                                value={organization.identifier}
                                errorTrigger={identifierErrorTrigger}
                                errorMessage={'Identifier is required'}
                                placeholder="E.g. acme"
                                onChange={(e) => {
                                    setOrganization({ ...organization, identifier: e.target.value.toLowerCase() })
                                    setOrgIdEdited(true);
                                    setIdentifierErrorTrigger(false);
                                }}
                                information={<span>This will be used to create your organization domain.<br />E.g. <i>acme.simple.events</i><br /><strong><span className="danger">Warning:</span><br />This can not be changed later.</strong></span>}
                                subText={organization.identifier ? `https://${organization.identifier}.simple.events` : ''}
                            />
                            <SelectField
                                label={'Organization Size'}
                                type={'select'}
                                value={sizeOptions.find(size => size.value === organization.size)}
                                errorMessage={'Size is required'}
                                placeholder="Select"
                                options={sizeOptions}
                                onChange={(e) => setOrganization({ ...organization, size: e.value })}
                            />
                            <SelectField
                                label={'Industry'}
                                type={'select'}
                                value={industryOptions.find(industry => industry.value === organization.industry)}
                                errorMessage={'Industry is required'}
                                placeholder="Select"
                                options={industryOptions}
                                onChange={(e) => setOrganization({ ...organization, industry: e.value })}
                            />
                            <SelectField
                                label={'Country'}
                                type={'select'}
                                value={countryOptions.find(country => country.value === organization.country)}
                                errorMessage={'Country is required'}
                                placeholder="Select"
                                options={countryOptions}
                                onChange={(e) => setOrganization({ ...organization, country: e.value })}
                            />
                            <button
                                onClick={continueToNextPart}
                                className={`prim ${disableSubmit ? 'inactive' : ''} w-100 mt-30`}
                                disabled={disableSubmit}
                            >
                                Continue
                            </button>
                        </>}

                        {activePart === 1 && <>
                            <h1 className='text-c mb-30' style={{ fontWeight: 500, fontSize: 24 }}>Setup Your Brand</h1>
                            <FileUploadInputBox
                                label="Logo"
                                addText="Image"
                                value={organization.branding.logo}
                                onClick={() => {
                                    let { branding } = organization;
                                    branding.logo = 'choosing__' + branding.logo;
                                    setOrganization({ ...organization, branding });
                                }}
                                clearFile={() => {
                                    let { branding } = organization;
                                    branding.logo = '';
                                    setOrganization({ ...organization, branding });
                                }}
                                information={
                                    'Your logo will automatically display in your emails and pages. We recommend a .PNG file with transparency to ensure it looks great on all backgrounds.'
                                }
                            />
                            <ColorField
                                label="Primary Color"
                                type="color"
                                useHex={true}
                                value={organization.branding.accentColor}
                                useDefaultColorEvent={true}
                                onChange={(e) => {
                                    let { branding } = organization;
                                    if (e.rgb) {
                                        let rgbValue = [e.rgb.r, e.rgb.g, e.rgb.b];
                                        let color = Math.round(((parseInt(rgbValue[0]) * 299) +
                                            (parseInt(rgbValue[1]) * 587) +
                                            (parseInt(rgbValue[2]) * 114)) / 1000);
                                        let textColor = (color > 125) ? '#000' : '#fff';
                                        branding.accentColor = e.hex;
                                        branding.textColor = textColor;
                                        setOrganization({ ...organization, branding });
                                    } else {
                                        branding.accentColor = e;
                                        branding.textColor = '#000';
                                        setOrganization({ ...organization, branding });
                                    }
                                }}
                                placeholder="#000"
                            />
                            <ColorField
                                label="Secondary Color"
                                value={organization.branding.fontColor}
                                type="color"
                                useHex={true}
                                onChange={(color) => {
                                    let { branding } = organization;
                                    branding.fontColor = color;
                                    setOrganization({ ...organization, branding });
                                }}
                                placeholder="#000"
                            />
                            <div className="flex gap10 mt-30">
                                <button
                                    onClick={
                                        () => {
                                            setActivePart(0);
                                        }
                                    }
                                    className={`outline w-100 `}
                                    disabled={disableSubmit}
                                >
                                    Previous
                                </button>
                                <button
                                    onClick={continueToNextPart}
                                    className={`prim ${disableSubmit ? 'inactive' : ''} w-100`}
                                    disabled={disableSubmit}
                                >
                                    Continue
                                </button>
                            </div>
                        </>}
                    </div>
                </div>
            </div>
        )
    }

    function Step3() {
        return (
            <div>
                <h1>Step 3</h1>
                <button onClick={() => setStep(4)}>Next</button>
            </div>
        )
    }

    return (
        <div className="w-100 h-100 onboardingContainer">
            {step === 1 && <Step1 />}
            {step === 2 && <Step2 />}
            {step === 3 && <Step3 />}
        </div>
    );
}

export default Onboard;